export const FORMAT = {
    /**
     * Date format: 'YYYY-MM-DD HH:mm:ss'
     * @static
     * @memberof FORMAT
     */
    DATETIME_SERVER: 'YYYY-MM-DD HH:mm:ss',

    /**
     * Date format: 'YYYY-MM-DD HH:mm A'
     * @static
     * @memberof FORMAT
     */
    DATETIME_IMPORT: 'YYYY-MM-DD HH:mm A',

    /**
     * Date format: 'YYYY-MM-DD HH:mm'
     * @static
     * @memberof FORMAT
     */
    DATETIME_SHORT: 'YYYY-MM-DD HH:mm',

    /**
     * Date format: 'YYYY-MM-DDTHH:mm:ssZ'
     * @static
     * @memberof FORMAT
     */
    DATETIME_INTEGRATIONS_SERVER: 'YYYY-MM-DDTHH:mm:ssZ',

    /**
     * Date format: 'YYYY-MM-DD HH:mm:ss'
     * @static
     * @memberof FORMAT
     */
    DATETIME_LONG: 'YYYY-MM-DD HH:mm:ss',

    /**
     * Date format: 'YYYY-MM-DD'
     * @static
     * @memberof FORMAT
     */
    DATE_SHORT: 'YYYY-MM-DD',

    /**
     * Date format: 'YYYY MM DD'
     * @static
     * @memberof FORMAT
     */
    DATE_SHORT_2: 'YYYY MM DD',

    /**
     * DATE_MINIMAL: 'DMMMYYYY',
     * Example: '25Oct2018'
     * Date format: 'YYYY-MM-DD'
     * @static
     * @memberof FORMAT
     */
    DATE_MINIMAL: 'DMMMYYYY',

    /**
     * Date format: 'D MMM'
     * @static
     * @memberof FORMAT
     */
    DATE_MICRO: 'D MMM',

    DAY_HEADER_LG: 'dddd, MMM D YYYY',
    DAY_HEADER_MD: 'ddd D',
    DAY_HEADER_SM: 'dd D',

    /**
     * Date format: 'D MMMM h:mma'
     * @static
     * @memberof FORMAT
     */
    DATE_MONTH_TIME: 'D MMMM h:mma',

    /**
     * Date format: 'DD MMM YYYY'
     * @static
     * @memberof FORMAT
     */
    DATE_LONG: 'DD MMM YYYY',

    /**
     * Date format: 'D MMM YYYY'
     * @static
     * @memberof FORMAT
     */
    DATE_LONG_2: 'D MMM YYYY',

    /**
     * Date format: 'MMM D'
     * @static
     * @memberof FORMAT
     */
    MONTH_AND_DATE: 'MMMM D',

    /**
     * Date format: 'MMM D'
     * @static
     * @memberof FORMAT
     */
    FULL_MONTH_AND_DATE: 'MMMM D',

    /**
     * Date format: 'MMMM Do'
     * Example: 'June 20th'
     * @static
     * @memberof FORMAT
     */
    MONTH_AND_DATE_WITH_ORDER: 'MMMM Do',

    /**
     * Date format: 'MMMM, YYYY'
     * @static
     * @memberof FORMAT
     */
    MONTH_AND_YEAR: 'MMMM, YYYY',

    /**
     * Date format: 'HH:mm:ss'
     * @static
     * @memberof FORMAT
     */
    TIME_LONG: 'HH:mm:ss',

    /**
     * Date format: 'HH:mm'
     * @static
     * @memberof FORMAT
     */
    TIME_SHORT: 'HH:mm',

    /**
     * Date format: 'h:mma'
     * @static
     * @memberof FORMAT
     */
    TIME_SHORT_WITH_MERIDIAN: 'h:mma',

    /**
     * Date format: 'hh:mm'
     * @static
     * @memberof FORMAT
     */
    TIME_SHORT_12: 'hh:mm',

    /**
     * Date format: 'A'
     * @static
     * @memberof FORMAT
     */
    MERIDIAN: 'A',

    /**
     * Date format: 'h:mm A'
     * @static
     * @memberof FORMAT
     */
    TIME_MERIDIAN: 'h:mm A',

    /**
     * Date format: 'h:mm A'
     * @static
     * @memberof FORMAT
     */
    TIME_HOURS: 'h A',

    /**
     * Date format: 'hh:mmA'. Used for displaying time in OSS app
     * @static
     * @memberof FORMAT
     */
    TIME_DISPLAY: 'hh:mmA',

    TIME_SHIFT: 'h:mm',

    /**
     * Date format: 'h:mma'. Used for displaying time in OSS app
     * @static
     * @memberof FORMAT
     */
    TIME_DISPLAY_2: 'h:mma',

    /**
     * Date format: 'ha'. Used for displaying time in OSS app
     * @static
     * @memberof FORMAT
     */
    HOUR_DISPLAY: 'ha',

    /**
     * Date format: 'dddd, MMM D'
     * @static
     * @memberof FORMAT
     */
    DATETIME_LONG_WEEK_DAY: 'dddd, MMM D',

    /**
     * Date format: ddd, D MMM YYYY
     */
    DAY_DATE_MONTH_YEAR: 'ddd, D MMM YYYY',

    /**
     * Date format: DD/MMM/YYYY
     *
     */
    DATE_INPUT: 'DD/MMM/YYYY',

    /**
     * Date format: ddd, D MMM YYYY hh:mm:ss A
     */
    FULL_DAY_DATE_TIME: 'ddd, D MMM YYYY hh:mm:ss A',

    /**
     * Date format: ddd, D MMMM YYYY
     */
    DAY_DATE_LONG_MONTH_YEAR: 'ddd, D MMMM YYYY',

    /**
     * Date format: D MMMM YYYY
     */
    DATE_LONG_MONTH_YEAR: 'D MMMM YYYY',

    /**
     * Date format: D MMMM YYYY LT
     */
    DATE_LONG_MONTH_YEAR_WITH_TIME: 'D MMMM YYYY LT',

    /**
     * Date format: ddd, D MMMM
     */
    DAY_DATE_MONTH: 'ddd, D MMMM',

    /**
     * Date format: ddd, D MMM
     */
    DAY_DATE_MONTH_SHORT: 'ddd, D MMM',

    /**
     * Date and time: D MMMM YYYY LT
     *
     */
    DAY_MONTH_NAME_YEAR_TIME: 'D MMMM YYYY LT',

    /**
     * Date and time: dddd, D MMMM YYYY LT
     *
     */
    WEEKDAY_DAY_MONTH_NAME_YEAR_TIME: 'dddd, D MMMM YYYY LT',

    /**
     * Date format: MMM DD, YYYY
     */
    SHORT_MONTH_DATE_YEAR: 'MMM DD, YYYY',

    /**
     * Date format: MM/DD/YYYY
     */
    MONTH_DATE_YEAR_AMERICAN: 'MM/DD/YYYY',

    /**
     * Date format: MMMM DD, YYYY
     */
    LONG_MONTH_DATE_YEAR: 'MMMM DD, YYYY',

    /**
     * Time format: HH:mm:ssa
     */
    HOUR_MINUTE_SECONDS_MERIDIAN: 'hh:mm:ss A',

    DISPLAY_FORMAT_1: 'ddd, D MMM',
    DISPLAY_FORMAT_2: 'ddd, D MMM YYYY',
    DISPLAY_FORMAT_3: 'dddd, D MMMM',
    DISPLAY_FORMAT_4: 'ddd, MMM DD', // TODO: just feels repetitive format, can we use from 1 above??
    DISPLAY_FORMAT_5: 'hh:mma',
    DISPLAY_FORMAT_6: 'ddd, MMM D (h:mma)',
    DISPLAY_FORMAT_7: 'ddd, MMM DD YYYY',
    DISPLAY_FORMAT_8: 'ddd, MMM D YYYY',

    EPOC_DATE: '1970-01-01 00:00:01',
};
